import { BtnTripTypes } from './BtnTripTypes';

export default BtnTripTypes;
